import InlineTextEditor from 'components/admin2/ui/InlineTextEditor';
import { TEXT_100, TEXT_200 } from 'style/constants';
import { TEXT_BODY_XL_REGULAR, TEXT_DISPLAY_S, TEXT_LABEL_S_MEDIUM, TEXT_TITLE_M } from 'style/design-system/textStyles';
import styled, { css } from 'styled-components';
import { IBlockRegion } from '../utils';

export const Title = styled(InlineTextEditor)<{ region: IBlockRegion; }>`
  & .mce-content-body {
    color: ${TEXT_100};

    & * {
      ${TEXT_DISPLAY_S}
      text-align: center !important;

      ${({ region }) => region === 'panel' && css`
        ${TEXT_TITLE_M}
        font-size: 1.5rem !important;
      `}
    }
  }
`;

export const Description = styled(InlineTextEditor)<{ region: IBlockRegion; }>`
  & .mce-content-body {
    color: ${TEXT_200};

    & * {
      ${TEXT_BODY_XL_REGULAR}
      text-align: center !important;

      ${({ region }) => region === 'panel' && css`
        ${TEXT_LABEL_S_MEDIUM}
        font-size: 0.75rem !important;
      `}
    }
  }
`;

export const Wrapper = styled.header<{ region: IBlockRegion; }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 60px;

  ${({ region }) => region === 'panel' && css`
    margin-bottom: 20px;
    margin-inline: 6px;
  `};
`;
